import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import Booking from 'models/booking';
import { Location } from 'models/locations';

import CurrencySymbol from 'components/common/currency-symbol';

const propTypes = {
  booking: PropTypes.instanceOf(Booking).isRequired,
  location: PropTypes.instanceOf(Location).isRequired,
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  className: 'text-size-28 text-weight-book',
};

const Price = ({ booking, location, type, className }) => {
  let bookingPrice;

  switch (type) {
    case 'paid':
      bookingPrice = booking.getFormattedPrice('pricePaid');
      break;
    case 'full':
      bookingPrice = booking.getFormattedPrice('fullPrice');
      break;
    default:
      break;
  }

  const priceArray = get(bookingPrice, 'split', false) ? bookingPrice.split('.') : ['0'];

  return (
    <span className={`booking-price ${className}`}>
      <sup><CurrencySymbol location={location} /></sup>
      { priceArray[0] }
      <sup>{priceArray[1]}</sup>
    </span>
  );
};

Price.propTypes = propTypes;
Price.defaultProps = defaultProps;
export default Price;
